import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { getCategoryBySlug } from "@/mocks/categories";
import { formatDate } from "@/lib/content";

export default function DepthSpot() {
  const lead = articles[5];
  const category = getCategoryBySlug(lead.categorySlug);

  return (
    <section className="bg-primary-50 border-b border-background-200">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-5">
            <Link to={`/article/${lead.id}`} className="block w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src={lead.cover}
                alt={lead.coverAlt}
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
              />
            </Link>
          </div>

          <div className="lg:col-span-7">
            <p className="text-xs tracking-[0.18em] text-primary-700">本期深度 · {category?.name}</p>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl leading-snug text-foreground-950">
              <Link to={`/article/${lead.id}`} className="hover:text-primary-700 transition-colors">
                {lead.title}
              </Link>
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">{lead.excerpt}</p>

            <blockquote className="mt-6 pl-5 border-l-2 border-accent-500">
              <p className="font-heading text-lg md:text-xl leading-relaxed text-foreground-900">
                「我们以为自己在选择看什么，其实很多时候是在被时间选择。」
              </p>
            </blockquote>

            <div className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-600">
              <span>{lead.author}</span>
              <span>{formatDate(lead.date)}</span>
              <span className="flex items-center gap-1"><i className="ri-time-line"></i>{lead.readTime}</span>
            </div>

            <Link
              to={`/article/${lead.id}`}
              className="mt-7 inline-flex items-center gap-2 h-11 px-6 rounded-md bg-foreground-950 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              阅读全文
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}